import { Button, Typography } from "@mui/material";
import { sxButton, sxPaVirtualSubtitle } from "./sxProps";
import { useAccessibility } from "../../../Store/contexts/AccessibilityContext";

const StartScreening: React.FC<{ start: () => void }> = ({ start }) => {

  const accessibility = useAccessibility();

  return (
    <>
      <Typography sx={sxPaVirtualSubtitle} style={accessibility.textTitleStyleAccessibility}>Realize consultas por videochamadas com nossos médicos de plantão na segurança e conforto de sua casa.</Typography>
      <div className='margin-bottom-16' />
      <div className='pa-virtual-service-availability' tabIndex={0} style={{...accessibility.contrastStyle, ...accessibility.contrastBorderAccessibility }}>
        <Typography style={accessibility.textStyleAccessibility}><b>Horário de atendimento:</b></Typography>
        <div>
          <Typography style={accessibility.textStyleAccessibility}>Segunda a sexta, das 7h às 22h</Typography>
          <Typography style={accessibility.textStyleAccessibility}>Sábado e domingo, das 8h às 20h</Typography>
        </div>
      </div>
      <div className='margin-bottom-16' />
      <Typography style={accessibility.textStyleAccessibility} sx={sxPaVirtualSubtitle}>Ao clicar em <b>Iniciar</b>, você responderá algumas perguntas para prosseguir com o atendimento.</Typography>
      <div className='margin-bottom-16' />
      <Button variant="contained" sx={sxButton} onClick={start} style={accessibility.buttonStyleAccessibility}>
        <Typography style={accessibility.buttonTextStyleAccessibility}>INICIAR</Typography>
      </Button>
    </>
  )
}

export default StartScreening;